export default "/assets/images/mila-filters-boxes.10f10c5b69ac859e.png";